import React, { useEffect, useState } from 'react'
import '../index.css'
import Container from 'react-bootstrap/Container'
import Nav from 'react-bootstrap/Nav'
import Nv from 'react-bootstrap/Navbar'
import Offcanvas from 'react-bootstrap/Offcanvas'
import PersonIcon from '@mui/icons-material/Person'
import { useLocalStorage } from '../../../auth/useLocalStorage'
import { CommonService } from '../../../services/CommonService'
import { KitchenService } from '../../../services/KitchenService'
import ListGroup from 'react-bootstrap/ListGroup'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTheme } from '../../../context/ThemeContext'

interface NavbarProps {
  openList: (schedules?:boolean, doneOrders?:boolean) => void
}

const Navbar: React.FC<NavbarProps> = ({ openList }) => {
  const [user] = useLocalStorage('user', null)
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const [warehouse, setWarehouse] = useState<string>()
  const navigate = useNavigate()
  const location = useLocation()
  const { colors, areaName } = useTheme()
  useEffect(() => {
    CommonService.getWarehouse(user.warehouse_id).then((res) => {
      setWarehouse(res.name)
    })
  }, [])
  const expand = ''
  const logOut = () => {
    Promise.all([
      CommonService.logout(user?.id),
      KitchenService.update(user.kitchen_id, {
        status: 'close'
      })
    ]).then(() => {
      localStorage.clear()
      window.location.reload()
    })
  }
  return (
    <>
        <Nv sticky="top" key={expand} expand={expand} className="navbar mb-3">
        <Container fluid>
          <Nv.Brand href="#">
            <img
              className="img-fluid"
              src={`${process.env.PUBLIC_URL}/bife.png`}
              alt="logo"
              style={{ width: '50px' }}
            />
          </Nv.Brand>

          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <Nv.Text>
              SUCURSAL: {warehouse ?? ''}
            </Nv.Text>

            {/* Distintivo de área solo para piso de venta */}
            {location.pathname === '/sales-floor' && (
              <span className="area-badge">
                {colors.areaIcon} {areaName}
              </span>
            )}
          </div>

          <Nv.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} onClick={handleShow}/>
          <Nv.Offcanvas
            id={`offcanvasNavbar-expand-${expand}`}
            aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
            placement="end"
            show={show}
            onHide={handleClose}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                <PersonIcon /> {user.user.nombre ?? ''}
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <ListGroup>
                {/* Mostrar opción de Cocina solo si el usuario tiene acceso */}
                {(user.user?.perfil === 'Cocina' || user.user?.perfil === 'Administrador') && (
                  <ListGroup.Item>
                    <Nav.Link
                      onClick={() => {
                        navigate('/')
                        setShow(false)
                      }}
                      style={{
                        fontWeight: location.pathname === '/' ? 'bold' : 'normal',
                        color: location.pathname === '/' ? '#0d6efd' : 'inherit'
                      }}
                    >
                      🍳 Cocina
                    </Nav.Link>
                  </ListGroup.Item>
                )}

                {/* Mostrar opción de Piso de Venta solo si el usuario tiene acceso */}
                {(user.user?.perfil === 'PisoVenta' || user.user?.perfil === 'Administrador') && (
                  <ListGroup.Item>
                    <Nav.Link
                      onClick={() => {
                        navigate('/sales-floor')
                        setShow(false)
                      }}
                      style={{
                        fontWeight: location.pathname === '/sales-floor' ? 'bold' : 'normal',
                        color: location.pathname === '/sales-floor' ? '#0d6efd' : 'inherit'
                      }}
                    >
                      🏪 Piso de Venta
                    </Nav.Link>
                  </ListGroup.Item>
                )}

                <ListGroup.Item>
                  <hr className="my-2" />
                </ListGroup.Item>
                <ListGroup.Item>
                  <Nav.Link onClick={() => {
                    openList()
                    setShow(false)
                  }}>
                    📋 Historico de Pedidos
                  </Nav.Link>
                </ListGroup.Item>
                <ListGroup.Item>
                  <Nav.Link onClick={() => {
                    openList(true)
                    setShow(false)
                  }}>
                    📅 Pedidos Agendados
                  </Nav.Link>
                </ListGroup.Item>
                <ListGroup.Item>
                  <hr className="my-2" />
                </ListGroup.Item>
                <ListGroup.Item>
                  <Nav.Link onClick={logOut}>🚪 Cerrar Sesión</Nav.Link>
                </ListGroup.Item>
              </ListGroup>
            </Offcanvas.Body>
          </Nv.Offcanvas>
        </Container>
      </Nv>
    </>
  )
}

export default Navbar
